/**
 * (c) 2022, Nous Educational Foundation and contributors
 *
 * SPDX-License-Identifier: MIT
 */
export const zIndexCode = 1;
export const zIndexBreadcrumbContainer = 2;
export const zIndexProjectAreaMenu = 3;
export const zIndexCodePopUp = 3;
export const zIndexSidebarHeader = 3;
export const splitViewDivider = 3;
export const splitViewHideButton = 4;
// z-index above the xterm.js's layers (currently 10 but given some margin for increases as it can vary with config)
export const zIndexAboveTerminal = 20;
export const zIndexOverlay = 30;
export const zIndexAboveDialogs = 1500;
